/*
Written by Kevin Kasey and Austin Thibodeaux in June 2021
Documented by Austin Thibodeaux in April 2023

Component name:     InTransitList
Purpose:            Displays a multi-column list of in-transit flights.
                    For each flight, the carrier name and expected/departing counts are displayed.
*/

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from 'antd';
import NonIdealState from 'components/NonIdealState';
import React from 'react';

export interface InTransitListProps {
	data: Array<{
		carrierID: string;
		carrierName: string;
		classType: string;
		expectedCount: number;
		departingCount: number;
	}>;
	style?: React.CSSProperties;
	onInTransitLocClick?: (id: string, name: string, classType: string) => void;
	selectedID?: string;
	offshoreLocationSelected?: boolean;
}

/* ------------------  LOOP OVER LOCATION QUERY --------------------*/
const InTransitList: React.FC<InTransitListProps> = (props) => {
	const transitRows = props.offshoreLocationSelected
		? props.data.map((item) => (
				<dd
					key={item?.carrierID}
					className={`list-item ${props.selectedID === item.carrierID ? 'active' : ''}`}
					onClick={() =>
						props.onInTransitLocClick?.(item.carrierID, item.carrierName, item.classType)
					}
				>
					<FontAwesomeIcon icon={['fas', 'helicopter']} className='mc-qm-icon' />
					<span className='title'>{item.carrierName}</span>
					<div className='destinfowrap'>
						<span className='destinfo'>{item.expectedCount}</span>
						<span className='destinfo'>{item.departingCount}</span>
					</div>
				</dd>
		  ))
		: null;

	return (
		<>
			<div
				className='dashboard'
				style={{ ...props.style, display: 'flex', flexDirection: 'column' }}
			>
				<dl className='list-group bordered'>
					<dt className='list-header'>
						<span className='title'>In Transit</span>
						<div className='destinfowrap'>
							<span className='mc-qm-loc-list-header mc-qm-loc-list-header-expected'>
								<Tooltip title='Expected Passengers'>
									<FontAwesomeIcon icon={['fas', 'level-down-alt']} />
								</Tooltip>
							</span>
							<span className='mc-qm-loc-list-header mc-qm-loc-list-header-departing'>
								<Tooltip title='Departing Passengers'>
									<FontAwesomeIcon icon={['fas', 'level-up-alt']} />
								</Tooltip>
							</span>
						</div>
					</dt>

					{transitRows}
				</dl>
				{!props.offshoreLocationSelected ? (
					<NonIdealState
						title={
							<span style={{ color: 'rgba(255, 255, 255, 0.65)' }}>
								Choose an offshore location
							</span>
						}
						icon='exclamation-circle'
						iconProps={{ style: { color: 'rgba(255, 255, 255, 0.65)' } }}
					/>
				) : null}
			</div>
		</>
	);
};

export default InTransitList;
